export default __webpack_public_path__ + "static/reg-ae084ad9eff433005437f07398ba5963.pdf";